<template>
  <div>
    <NavigationBar
      titel="Datenschutzerklärung der Organisation"
      showBackBtn
    ></NavigationBar>

    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "organization-privacy-policy",
  components: {
    NavigationBar,
  },
  data() {
    return {};
  },
};
</script>
